"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var SkeletonFlex = function (_a) {
    var type = _a.type, justify = _a.justify, align = _a.align, padding = _a.padding, margin = _a.margin, flex = _a.flex, width = _a.width, height = _a.height, borderRadius = _a.borderRadius, children = _a.children, className = _a.className, customStyle = _a.style;
    var style = __assign({ display: 'flex', flexDirection: type, justifyContent: justify, alignItems: align, padding: padding, margin: margin, flex: flex, width: width, height: height, borderRadius: borderRadius }, customStyle);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('skeleton-form', className), style: style, "data-testid": "skeleton-container" }, children));
};
exports.default = SkeletonFlex;
